/**
 * True if val contains an invalid field-vchar
 *  field-value    = *( field-content / obs-fold )
 *  field-content  = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 *  field-vchar    = VCHAR / obs-text
 **/
function checkInvalidHeaderChar(val: unknown) {
  const stringVal = String(val);
  for (let i = 0; i < stringVal.length; i++) {
    const ch = stringVal.charCodeAt(i);
    if (ch === 9) continue;
    if (ch <= 31 || ch > 255 || ch === 127) {
      return true;
    }
  }
  return false;
}

//Reverse the logic to keep interface consistent
function validHeaderValue(val: unknown) {
  return !checkInvalidHeaderChar(val);
}

//Same logic as checkInvalidHeaderChar, which removes all invalid chars
function cleanHeaderValue(val: unknown) {
  const stringVal = String(val);
  let cleanVal = '';
  for (let i = 0; i < stringVal.length; i++) {
    const ch = stringVal.charCodeAt(i);
    if (ch === 9 || ch <= 31 || ch > 255 || ch === 127) {
      continue;
    } else {
      cleanVal += stringVal[i];
    }
  }
  return cleanVal;
}

export function createCookieString(cookieObj: Record<string, string> = {}) {
  const cookies: Record<string, string> = {};

  Object.keys(cookieObj).forEach((key) => {
    if (!validHeaderValue(cookieObj[key])) {
      cookies[key] = cleanHeaderValue(cookieObj[key]);
    } else {
      cookies[key] = cookieObj[key];
    }
  });

  let cookieString = '';

  Object.entries(cookies).forEach(([key, val]) => {
    cookieString += `${key}=${val};`;
  });

  return cookieString;
}
